import '../index.scss';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { translate } from '@utils';

export const DeleteModal = (props) => {
  const {
    handleCancel,
    handleConfirmation,
    open,
    contentName,
    title,
    isDisabledConfirmationButton,
  } = props;

  return (
    <Dialog
      className="delete-modal"
      data-testid="delete-modal"
      keepMounted
      open={open}
      onClose={handleCancel}
    >
      <DialogTitle data-testid="delete-modal-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className="delete-modal__content-text">
          {translate(contentName)}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          className="actions-button delete"
          data-testid="button-delete-modal"
          onClick={handleConfirmation}
          disableRipple
          disabled={isDisabledConfirmationButton}
        >
          {translate('delete')}
        </Button>
        <Button
          className="actions-button cancel"
          data-testid="button-cancel-modal"
          onClick={handleCancel}
          disableRipple
        >
          {translate('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
